var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['plotsLine']},[_c('div',_vm._g({class:_vm.$style['plotsList']},_vm.$listeners),[_c('PlotsLineSlider',{attrs:{"plots":_vm.plots},on:{"sendNewReachGoal":function($event){return _vm.sendNewReachGoal($event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }